import { createAuth0 } from '@auth0/auth0-vue'

function createProductionRedirect(): string {
  return 'https://app.hearseemobility.org' + (location.pathname + location.search).substring(1)
}

const isRunningUnderCypress = () => 'Cypress' in window

export const auth0 = createAuth0({
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  useRefreshTokens: true,
  cacheLocation: isRunningUnderCypress() ? 'localstorage' : 'memory',
  authorizationParams: {
    audience: import.meta.env.VITE_AUTH0_API_AUDIENCE,
    redirect_uri:
      import.meta.env.MODE === 'staging' ? createProductionRedirect() : window.location.origin,
    scope: 'openid profile email offline_access',
  },
})
